import { rolClient, RolListaDto, RolDetalleDto, CrearRolDto, ActualizarRolDto } from '@/core/sdk/modules/administracion/rolClient';

/**
 * Servicio de roles que expone métodos para gestión de roles
 */
export const rolService = {
    /**
     * Obtener todos los roles
     */
    getAll: async (): Promise<RolListaDto[]> => {
        const response = await rolClient.listar();

        if (!response.success || !response.data) {
            throw new Error(response.message || 'Error al obtener roles');
        }

        // response.data ya es el array de roles directamente
        return response.data as any as RolListaDto[];
    },

    /**
     * Obtener un rol por ID
     */
    getById: async (id: number): Promise<RolDetalleDto> => {
        const response = await rolClient.obtener(id);

        if (!response.success || !response.data) {
            throw new Error(response.message || 'Error al obtener rol');
        }

        return response.data;
    },

    /**
     * Crear un nuevo rol
     */
    create: async (data: CrearRolDto): Promise<RolDetalleDto> => {
        const response = await rolClient.crear(data);

        if (!response.success || !response.data) {
            throw new Error(response.message || 'Error al crear rol');
        }

        return response.data;
    },

    /**
     * Actualizar un rol existente
     */
    update: async (id: number, data: ActualizarRolDto): Promise<RolDetalleDto> => {
        const response = await rolClient.actualizar(id, data);

        if (!response.success || !response.data) {
            throw new Error(response.message || 'Error al actualizar rol');
        }

        return response.data;
    },

    /**
     * Eliminar un rol
     */
    delete: async (id: number): Promise<void> => {
        const response = await rolClient.eliminar(id);

        if (!response.success) {
            throw new Error(response.message || 'Error al eliminar rol');
        }
    }
};

// Export por defecto y nombrado para máxima flexibilidad
export default rolService;
